/**
 * Returns a promise that succeeds when DOM markup is rendered
 * and doesn't wait for assets to be loaded
 * @returns null
 */
export default function waitDomReady() {
    return new Promise(success => {
        const onReadyCallback = (ev?) => {
            if (ev) {
                document.removeEventListener("DOMContentLoaded", onReadyCallback);
            }
            success(null);
        }
        if (/complete|interactive|loaded/.test(document.readyState)) {
            success(null);
        } else {
            document.addEventListener("DOMContentLoaded", onReadyCallback);
        }
    });
}